import { NavLink } from "react-router-dom";
import { loadScript, publicUrlFor } from "../../../globals/constants";
import { useEffect } from "react";
import Header from "../../sections/common/header";

export default function Error404Page() {

    useEffect(() => {
        loadScript('/assets/js/bg-image-move.js', true);
    }, []);

    return (
         <>
         
         <Header />
        <div className="error-404-wrapper">
            <div className="overlay" />
            <div className="error-content">
                <h1 className="error-code">404</h1>
                <h2 className="error-message">Page Not Found</h2>
                <p className="error-description">
                    Oops! The page you're looking for doesn't exist or has been moved.
                </p>
                <NavLink to="/" className="btn-back-home">Back to Home</NavLink>
            </div>
        </div></>
    );
}
